import { render, staticRenderFns } from "./MyCalendarComponent.vue?vue&type=template&id=b20fc03a"
import script from "./MyCalendarComponent.vue?vue&type=script&lang=js"
export * from "./MyCalendarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports